import { createContext, useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

export const MapDrawerContext = createContext(null);

export function MapDrawerContextProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [pois, setPois] = useState([]);

  const values = useMemo(
    () => ({
      open,
      setOpen,
      pois,
      setPois,
    }),
    [open, pois]
  );

  return (
    <MapDrawerContext.Provider value={values}>
      {children}
    </MapDrawerContext.Provider>
  );
}

export function useMapDrawer() {
  const ctx = useContext(MapDrawerContext);

  if (!ctx) {
    throw new Error(
      "useMapDrawer must be invoked within a DrawerContextProvider"
    );
  }

  return ctx;
}

MapDrawerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
